/* eslint-disable no-console */

import { register } from 'register-service-worker';

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log('SW App is being served from cache by a service worker.\n');
    },
    registered() {
      console.log('SW Service worker has been registered.');
    },
    cached() {
      console.log('SW Content has been cached for offline use.');
    },
    updatefound() {
      console.log('SW New content is downloading.');
    },
    updated() {
      console.log('SW New content is available; please refresh.');

      // caches.keys().then(function(names) {
      //   for (let name of names) caches.delete(name);
      // });
      //
      // if(window.navigator && navigator.serviceWorker) {
      //   navigator.serviceWorker.getRegistrations()
      //     .then(function(registrations) {
      //       for(let registration of registrations) {
      //         registration.unregister();
      //       }
      //     });
      // }

      /* setTimeout(() => {
        window.location.reload(true)
      }, 1000); */
    },
    offline() {
      console.log(
        'SW No internet connection found. App is running in offline mode.'
      );
    },
    error(error) {
      console.error('SW Error during service worker registration:', error);
    }
  });
}
